import { useAuth } from "../services/auth/CognitoAuthContext";
import { Trans, useTranslation } from "react-i18next";
import React from "react";

import PageLayout from "../components/PageLayout.jsx";
import { useLocation, useNavigate } from "react-router-dom";

export default function AccessDenied({ groups, title = "Login Required" }) {
  const { session } = useAuth();
  return (
    <PageLayout title={title}>
      <section aria-labelledby="section-heading rounded-lg">
        <div className="relative rounded-lg px-6 py-32 sm:px-12 sm:py-40 lg:px-16">
          <div
            aria-hidden="true"
            className="bg-opacity-50 absolute inset-0 rounded-lg bg-gray-900 dark:bg-gray-600"
          ></div>
          <div className="dark relative mx-auto flex max-w-full flex-col items-center text-center">
            {session.authenticated && groups.length ? <PermissionDenied /> : <LoginRequired />}
          </div>
        </div>
      </section>
    </PageLayout>
  );
}

const LoginRequired = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  // sets redirect uri for login flow
  const authRedirect = (register) => {
    localStorage.setItem("redirectUri", location.pathname);
    navigate(register ? "/auth/register" : "/auth/login");
  };

  return (
    <>
      <h2 id="section-heading" className="text-lg font-bold tracking-tight lg:text-2xl">
        {t("403.title")}
      </h2>

      <button onClick={() => authRedirect(false)} className="button button-white mt-4">
        {t("proof.loginButton")}
      </button>
      <p className="text-primary mt-4 text-sm font-light">
        <Trans i18nKey="403.signup">
          Don’t have an account?{" "}
          <button
            onClick={() => authRedirect(true)}
            rel="noreferrer"
            className="font-medium underline hover:opacity-50"
          >
            Register
          </button>
        </Trans>
      </p>
    </>
  );
};

const PermissionDenied = () => {
  return (
    <>
      <h2 id="section-heading" className="text-lg font-bold tracking-tight text-white lg:text-2xl">
        <Trans i18nKey="401.title">401 - Permission Denied</Trans>
      </h2>

      <p className="text-primary mt-4 text-sm font-light">
        <Trans i18nKey="401.text">
          You do not have permission to view this page, return to{" "}
          <a className="font-medium underline hover:opacity-50" href="/">
            home
          </a>
        </Trans>
      </p>
    </>
  );
};
